import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { AlertService } from 'sce-core/components/alerts/alert.service';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { multipleFacility, shipmentOrder } from '../../../features/outbound/outbound-constants';
import { ButtonItem } from '../../button/button.model';
import { DataTableConfig } from '../../search/models/data-table-config';
import { Clause, Condition, SearchCriteria } from '../../search/models/search-filter-model';
import { SearchParams } from '../../search/models/search-params.model';
import { SearchStatus } from '../../search/models/search-status.model';
import { DataTableEditorService } from '../../search/results/data-table-editor.service';
import { SearchService } from '../../search/search.service';
import { SharedServiceRegistry } from '../../shared-service-registry';


@Component({
    selector: 'lfwms-populate-pick-detail-popup',
    templateUrl: './populate-pick-detail-popup.html',
    styleUrls: ['./populate-pick-detail-popup.css']
})
export class PopulatePickDetailPopupComponent {
    public searchService: SearchService;
    public searchParams: SearchParams;
    public searchStatus: SearchStatus;
    private http$ = this.coreServiceRegistry.http$;
    public resourceService = this.coreServiceRegistry.resourceService;
    public type: string;
    public eventSubject = new Subject<any>();
    public skuValue: any;

    constructor(
        private coreServiceRegistry: CoreServiceRegistry,
        private sharedServiceRegistry: SharedServiceRegistry,
        private alertService: AlertService) {
        this.eventSubject = new Subject<any>();
    }

    public initializeComponents(selectedrow) {
        const tabledId = shipmentOrder.POPULATE_TABLE_ID;
        this.skuValue = selectedrow[0].cells.sku.cVal
        this.searchParams = this.createLookupParamsForColumn(tabledId);
        this.searchParams.alertService = this.alertService;
        const searchStatus = new SearchStatus();
        this.searchService = this.sharedServiceRegistry.createSearchService(this.searchParams, searchStatus);
        this.searchService.setSearchCriteria(this.createSearchCriteria(this.skuValue));
        this.searchStatus = this.searchService.searchStatus;
    }

    protected createLookupParamsForColumn(tableId: string) {
        const searchParams = new SearchParams();
        searchParams.tableId = tableId;
        searchParams.isFullFetch = true;
        searchParams.columnCount = 10;
        const tableConfig: DataTableConfig = new DataTableConfig();
        tableConfig.supportFiltering = true;
        searchParams.dataTableConfig = tableConfig;
        searchParams.actionButtons = [
            new ButtonItem('Populate', this.resourceService.get('lbl_populate'), 'asn_pop', 'icon_populate.svg', [])];
        const tableEditor: DataTableEditorService = new DataTableEditorService(this.coreServiceRegistry,
            this.sharedServiceRegistry);
        searchParams.tableEditor = tableEditor;
        const searchStatus = new SearchStatus();
        return searchParams;
    }

    protected createSearchCriteria(skuVal) {
        const defaultSearchCriteria = new SearchCriteria();
        defaultSearchCriteria.conditions = [];
        defaultSearchCriteria.loadDefaultCriteria = false;

        const defaultCondition = this.createDefaultSearchCondition(1);
        defaultCondition.isReadOnly = false;
        defaultCondition.isMandatory = true;
        defaultCondition.operator = multipleFacility.OPERATIONS.AND;

        // SKU Clause
        const skuClause = new Clause();
        skuClause.column = shipmentOrder.COLUMN_NAMES.SKU_NAME;
        skuClause.value = skuVal;
        skuClause.operation = multipleFacility.OPERATIONS.EQUAL
        skuClause.logicalOperation = multipleFacility.OPERATIONS.AND;

        // AvailableQty Clause
        const availableQtyClause = new Clause();
        availableQtyClause.column = shipmentOrder.COLUMN_NAMES.AVAILABLE_QTY;
        availableQtyClause.value = '0';
        availableQtyClause.operation = multipleFacility.OPERATIONS.GREATER_THAN;
        availableQtyClause.logicalOperation = multipleFacility.OPERATIONS.AND;

        // Assign clauses to condition
        defaultCondition.clauses = [skuClause, availableQtyClause];
        defaultSearchCriteria.conditions.push(defaultCondition);

        return defaultSearchCriteria;
    }


    /**
     * create an instance of condition
     * @param id
     */
    protected createSearchCondition(id: any) {
        const defaultCondition = new Condition();
        defaultCondition.id = id;
        defaultCondition.displayMode = shipmentOrder.TABLE_MODES.VIEW
        return defaultCondition;
    }

    public handleButtonAction($event) {
        // Currently only populate button
        if ($event === 'Populate') {
            this.handlePopulateAction();
        }
    }

    public handlePopulateAction() {
        const selectedRows = this.searchService.getSelectedRows();

        if (selectedRows.length === 0) {
            this.alertService.error(this.resourceService.get(shipmentOrder.MESSAGE.NO_DETAIL_SELECTED_ALERT_MES));
            return;
        }
        const populateEvent = { 'type': 'populate', 'selectedItems': selectedRows };
        this.notifyEvent(populateEvent);
    }

    public notifyEvent(value: any) {
        this.eventSubject.next(value);
    }

    public receiveEvent(): Observable<any> {
        return this.eventSubject.asObservable();
    }


    protected createDefaultSearchCondition(id: any) {
        const defaultCondition = new Condition();
        defaultCondition.id = id;
        defaultCondition.displayMode = shipmentOrder.TABLE_MODES.VIEW;
        return defaultCondition;
    }

}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/populate-pick-detail-popup/populate-pick-detail-popup.ts